export default "__VITE_ASSET__0a05bdf7__"